import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
/**
 * Validation for adding frame extensions
 * - Can't add multiple extensions on corner frame
 * - Can't have more than 2 extensions on a frame
 */
export class FrameExtensionValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'FrameExtensionValidation');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const guest = snapActionCandidate.guestRoot;
        const guestProductType = this.coreApi.entities.getProductType(guest);
        const host = snapActionCandidate.host;
        const hostProductType = this.coreApi.entities.getProductType(host);
        if (guestProductType !== ProductType.BILLY_FRAME_EXTENSION) {
            return this.validationOK();
        }
        if (hostProductType === ProductType.BILLY_FRAME) {
            return this.validationOK();
        }
        else if (hostProductType === ProductType.BILLY_FRAME_EXTENSION &&
            this.isExtensionPlacedInCorner(host)) {
            return this.validationFail('Can`t add multiple extensions on corner frame');
        }
        else if (hostProductType === ProductType.BILLY_FRAME_EXTENSION) {
            const hostParent = HierarchyUtils.parent(host);
            if (hostParent) {
                const hostParentProductType = this.coreApi.entities.getProductType(hostParent);
                if (hostParentProductType === ProductType.BILLY_FRAME_EXTENSION) {
                    return this.validationFail('Can`t have more than 2 extensions on a frame');
                }
            }
        }
        return this.validationOK();
    }
    isFramePlacedInCorner(frame) {
        const frameAssembly = HierarchyUtils.parent(frame);
        return (frameAssembly?.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)?.highestPriorityConnection?.guestConnector.key === 'wall-corner');
    }
    isExtensionPlacedInCorner(extensions) {
        const parent = HierarchyUtils.parent(extensions);
        return parent ? this.isFramePlacedInCorner(parent) : false;
    }
}
//# sourceMappingURL=FrameExtensionValidation.js.map